import { SOURCE_TMS } from './recordSource';

/**
 * ADR zlecenia na karcie (odpowiedzi Marathonu/Euvic 16.10.2026, pyt. 52):
 * jedyne źródło to pole `adr` (true/false) w `/route-orders` TMS. Przy
 * zleceniu z TMS mówimy, skąd wartość; brak pola w TMS to brak danych, nie
 * „bez ADR”. Wiersz spoza TMS (prezlecenie, dane pokazowe) — sama wartość.
 */
export function orderAdrText(record: Record<string, unknown> | undefined): string {
  const fromTms = record?.sourceSystem === SOURCE_TMS;
  const adr = record?.adr;
  if (adr === true) return fromTms ? 'tak (z TMS)' : 'tak';
  if (adr === false) return fromTms ? 'nie (z TMS)' : 'nie';
  return fromTms ? 'brak danych w TMS' : '—';
}
